import { render, staticRenderFns } from "./TutorialModal.vue?vue&type=template&id=265e10af"
import script from "./TutorialModal.vue?vue&type=script&lang=ts"
export * from "./TutorialModal.vue?vue&type=script&lang=ts"
import style0 from "./TutorialModal.vue?vue&type=style&index=0&id=265e10af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports